import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useGetNoticeBoardsQuery } from '../redux/noticeBoardApi';
import { isProbablyHtml, stripDangerousHtml } from '../utils/notificationHtml';

function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}

function NoticeDescription({ notice }) {
  if (!notice.description) return null;

  if (isProbablyHtml(notice.description)) {
    return (
      <div
        className="text-sm leading-relaxed text-gray-700 [&_b]:font-semibold [&_p]:m-0 [&_p]:mb-1 [&_p:last-child]:mb-0 [&_strong]:font-semibold"
        dangerouslySetInnerHTML={{
          __html: stripDangerousHtml(notice.description),
        }}
      />
    );
  }

  return <p className="text-sm leading-relaxed text-gray-700">{notice.description}</p>;
}

function NoticeBoard({ notices: noticesProp }) {
  const shouldFetch = !Array.isArray(noticesProp);
  const { data: res } = useGetNoticeBoardsQuery(undefined, {
    skip: !shouldFetch,
  });

  const notices = useMemo(() => {
    const list = Array.isArray(noticesProp) ? noticesProp : res?.data || [];
    if (!Array.isArray(list)) return [];

    return list
      .slice()
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(0, 6);
  }, [noticesProp, res]);

  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm sm:p-6">
      <h3 className="mb-3 text-base font-semibold text-gray-900">Notice Board</h3>
      <ul className="space-y-4">
        {notices.map((notice) => (
          <li
            key={notice.id}
            className="border-b border-gray-200 pb-4 last:border-b-0 last:pb-0"
          >
            <div className="flex flex-col gap-3">
              <NoticeDescription notice={notice} />
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="inline-flex rounded-full bg-[#F7E5D5] px-3 py-1 text-xs font-medium text-gray-800">
                  {formatDate(notice.created_at)}
                </span>
                <Link
                  to={`/notice/${notice.id}`}
                  className="shrink-0 text-xs font-semibold text-brand underline"
                >
                  View Detail
                </Link>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NoticeBoard;
